import { __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var Previous = function (props) {
  return React__default.createElement("svg", __assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M7.39922 13.0001H18.5742C18.8576 13.0001 19.0951 12.9043 19.2867 12.7126C19.4784 12.5209 19.5742 12.2834 19.5742 12.0001C19.5742 11.7168 19.4784 11.4793 19.2867 11.2876C19.0951 11.0959 18.8576 11.0001 18.5742 11.0001H7.39922L12.2992 6.10011C12.4992 5.90011 12.5951 5.66678 12.5867 5.40011C12.5784 5.13344 12.4742 4.90011 12.2742 4.70011C12.0742 4.51678 11.8409 4.42094 11.5742 4.41261C11.3076 4.40428 11.0742 4.50011 10.8742 4.70011L4.27422 11.3001C4.17422 11.4001 4.10338 11.5084 4.06172 11.6251C4.02005 11.7418 3.99922 11.8668 3.99922 12.0001C3.99922 12.1334 4.02005 12.2584 4.06172 12.3751C4.10338 12.4918 4.17422 12.6001 4.27422 12.7001L10.8742 19.3001C11.0576 19.4834 11.2867 19.5751 11.5617 19.5751C11.8367 19.5751 12.0742 19.4834 12.2742 19.3001C12.4742 19.1001 12.5742 18.8626 12.5742 18.5876C12.5742 18.3126 12.4742 18.0751 12.2742 17.8751L7.39922 13.0001Z",
    fill: "currentColor"
  }));
};
export { Previous as default };
//# sourceMappingURL=Previous.js.map
